import { PartialId } from '@attain-apps/string-builder'

/**
 * @see {@link DEFERRED_EXCLUSION_CATEGORY_ID}
 */
export const DEFERRED_EXCLUSION_CATEGORY_LABEL = 'Deferred'

/**
 * Workaround for adding a `Deferred` item to the F&A Categories single select
 * component in the AdjustmentComponent.
 *
 * TODO: We should come up with a better way to make this work
 */
export const DEFERRED_EXCLUSION_CATEGORY_ID = PartialId.from('deferred')
